import { Driver, DriverHook } from "driver.js";
import { defaultTourConfig } from ".";

// Export the tour steps so they can be reused in BrandGrandTour
export const brandAffiliatesPayoutTourSteps = [
  {
    element: "#payouts",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
          
            <div class="flex -space-x-2">
              <div class="w-6 h-6 bg-brand-200 rounded-full border-2 border-white flex items-center justify-center">
                <svg class="w-3 h-3 text-brand-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"></path>
                </svg>
              </div>
              <div class="w-6 h-6 bg-brand-300 rounded-full border-2 border-white flex items-center justify-center">
                <svg class="w-3 h-3 text-brand-700" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M3 17l6-6 4 4 8-8v3h2V4h-6v2h3l-7 7-4-4-6 6v2z"></path>
                </svg>
              </div>
              </div>
          </div>
          <div class="flex items-center gap-2">
            <span class="text-base font-semibold text-foreground">Payout Management</span>
          </div>
        </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground leading-relaxed">Manage affiliate payouts and track commission payments to your affiliates.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <div class="flex items-center gap-2 mb-2">
              <p class="text-xs font-medium text-brand-800">Payout Management Features:</p>
            </div>
            <ul class="text-xs text-brand-700 space-y-3">
              <li class="flex items-start gap-3">
                <div class="w-6 h-6 bg-brand-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg class="w-3 h-3 text-brand-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path>
                  </svg>
                </div>
                <div class="flex-1">
                  <div class="font-medium text-brand-800 mb-1">Commission Tracking</div>
                  <div class="text-brand-700">Monitor earned commissions for each affiliate.</div>
                </div>
              </li>
              <li class="flex items-start gap-3">
                <div class="w-6 h-6 bg-brand-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg class="w-3 h-3 text-brand-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"></path>
                  </svg>
                </div>
                <div class="flex-1">
                  <div class="font-medium text-brand-800 mb-1">Payment Processing</div>
                  <div class="text-brand-700">Process payments through multiple payment methods.</div>
                </div>
              </li>
              <li class="flex items-start gap-3">
                <div class="w-6 h-6 bg-brand-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg class="w-3 h-3 text-brand-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"></path>
                  </svg>
                </div>
                <div class="flex-1">
                  <div class="font-medium text-brand-800 mb-1">Payment History</div>
                  <div class="text-brand-700">View detailed payment history and reports.</div>
                </div>
              </li>
            </ul>
          </div>
          <div class="flex items-center gap-2 text-xs text-brand-600">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span>Keep your affiliates happy with timely and accurate payments</span>
          </div>
        </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#payouts-view-history",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
          <div class="flex -space-x-2">
            <div class="w-6 h-6 bg-brand-200 rounded-full border-2 border-white flex items-center justify-center">
              <svg class="w-3 h-3 text-brand-600" fill="currentColor" viewBox="0 0 24 24">
                <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
              </svg>
            </div>
            <div class="w-6 h-6 bg-brand-300 rounded-full border-2 border-white flex items-center justify-center">
              <svg class="w-3 h-3 text-brand-700" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <span class="text-base font-semibold text-foreground">Payment History</span>
          </div>
        </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground leading-relaxed">Track all payment transactions and view detailed payment history for your affiliates.</p>
          <div class="bg-brand-50 p-3 rounded-lg">
            <div class="flex items-center gap-2 mb-2">
              <p class="text-xs font-medium text-brand-800">Payment History Features:</p>
            </div>
            <ul class="text-xs text-brand-700 space-y-3">
              <li class="flex items-start gap-3">
                <div class="w-6 h-6 bg-brand-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg class="w-3 h-3 text-brand-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
                  </svg>
                </div>
                <div class="flex-1">
                  <div class="font-medium text-brand-800 mb-1">Transaction Records</div>
                  <div class="text-brand-700">View complete transaction history with timestamps.</div>
                </div>
              </li>
            </ul>
          </div>
          <div class="flex items-center gap-2 text-xs text-brand-600">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span>Maintain transparency with detailed payment records and analytics</span>
          </div>
        </div>`,
      side: "left" as const,
      align: "start" as const,
    },
  },
];

const startAffiliatesPayoutTour = (
  tourDriver: Driver,
  onNextClick: DriverHook,
  onPrevClick: DriverHook
) => {
  tourDriver.setConfig(defaultTourConfig);
  // Here we set the unique steps for the FIRST tour
  tourDriver.setSteps(
    brandAffiliatesPayoutTourSteps.map((step) => ({
      ...step,
      popover: {
        ...step.popover,
        onNextClick: (element, step, config) => {
          onNextClick(element, step, config);
          setTimeout(() => {
            tourDriver.moveNext();
          }, 200);
        },
        onPrevClick: (element, step, config) => {
          onPrevClick(element, step, config);
          setTimeout(() => {
            tourDriver.movePrevious();
          }, 200);
        },
      },
    }))
  );
  tourDriver.drive();
};

export default startAffiliatesPayoutTour;
